import classNames from 'classnames'
import { PlanTag } from 'components/planTag'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import { gradePriority } from 'utils/common'
import { ReactComponent as PlayIcon } from 'svg/play.svg'
import { ReactComponent as PauseIcon } from 'svg/pause.svg'
import { ReactComponent as TrashIcon } from 'svg/trash.svg'
import { contentVideoFormValues, FormValues } from 'utils/type'
import {
  FieldValues,
  Path,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { VoiceGroupFactor } from 'service/list'
import { ClipLoaderSpinner } from 'components/spinner/ClipLoaderSpinner'

interface VoiceFormFields extends FieldValues {
  userVoiceId: number
  voiceId: number
}
interface UserVoiceDivProps<T extends VoiceFormFields> {
  id: number
  index: number

  className?: string
  planName?: string
  cashRate?: number
  voice: VoiceGroupFactor
  setVoiceName: Dispatch<SetStateAction<string>>
  watch: UseFormWatch<T>
  setValue: UseFormSetValue<T>
  userPlan?: string | null
  userVoiceRefetch: any
}
export const UserVoiceDiv = <T extends VoiceFormFields>({
  id,
  index,
  className,
  setVoiceName,
  planName,
  cashRate,
  userPlan,
  voice,
  watch,
  setValue,
  userVoiceRefetch,
}: PropsWithChildren<UserVoiceDivProps<T>>) => {
  const checked = watch('userVoiceId' as Path<T>) === voice.id
  const disabled = voice?.usable === 0

  const audioRef = useRef<HTMLAudioElement | null>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const handleClick = () => {
    //클릭하면 setValue userVoiceIdr가 선택, voiceId가 0으로 변환

    setValue('userVoiceId' as Path<T>, voice.id as any)
    setValue('voiceId' as Path<T>, 0 as any)
    setVoiceName(voice?.name)
  }

  const handleAudioToggle = () => {
    if (!audioRef.current) return

    if (isPlaying) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  useEffect(() => {
    const audio = audioRef.current
    if (!audio) return

    const handleEnded = () => setIsPlaying(false)
    audio.addEventListener('ended', handleEnded)

    return () => {
      audio.removeEventListener('ended', handleEnded)
    }
  }, [])
  return (
    <div
      className={classNames('cursor-pointer', {
        'w-[348px] h-[54px] flex gap-[8px] justify-between md:items-center  rounded-[4px] px-4':
          !isMobile,
        'w-full h-[54px]  flex gap-[8px] justify-between bg-white  items-center px-2':
          isMobile,
        'relative overflow-hidden w-full bg-gray-200 h-[54ps]':
          voice?.status !== 'completed',
        'bg-white': voice?.status === 'completed',
      })}
      key={`user_voice_${index}`}
    >
      {voice?.status === 'completed' ? (
        <>
          {' '}
          <div className="flex w-full" onClick={handleClick}>
            <div className="relative flex items-center">
              <div className="relative flex items-center cursor-pointer">
                <div
                  className={classNames(
                    'w-[20px] h-[20px] rounded-full border-2 flex items-center justify-center ',
                    {
                      'bg-white, border-main': checked,
                      'bg-white': !checked,
                    }
                  )}
                >
                  {checked && (
                    <div className="w-3 h-3 bg-main rounded-full"></div>
                  )}
                </div>
              </div>
            </div>

            <span
              className={classNames('text-[#2E343D] md:text-[18px] ml-2', {
                [`${className}`]: className,
                'opacity-30': !checked && disabled,
              })}
            >
              {voice?.name}
            </span>
            {planName &&
              gradePriority[planName as 'PRO' | 'PREMIUM' | 'LIGHT'] >
                gradePriority[userPlan as 'PRO' | 'PREMIUM' | 'LIGHT'] && (
                <div className="flex items-start h-full  p-t1 ml-[2px] mr-[8px]">
                  <PlanTag planName={planName} className="" />
                </div>
              )}

            <span className="flex items-start h-full  p-t1 ml-[2px] mr-[8px]">
              {new Array(4).fill(0).map((el, i) => (
                <>
                  {' '}
                  <img
                    src="assets/img/cash.png"
                    alt="cash"
                    className="w-[11px] h-[13px] ml-[2px] mt-[2px]"
                  />
                </>
              ))}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <button type="button" onClick={handleAudioToggle} className="z-50">
              {!isPlaying ? <PlayIcon /> : <PauseIcon />}
            </button>
            <audio ref={audioRef} src={voice?.samplePath} preload="auto" />
          </div>
          {/* <button className="" type="button">
            <TrashIcon />
          </button> */}
        </>
      ) : (
        <>
          {' '}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent animate-skeleton "></div>
          <span className="absolute left-4 top-4 ">
            {' '}
            <ClipLoaderSpinner color="black" size={20} />{' '}
          </span>
          <span className=" absolute left-12">목소리 생성중...</span>
          <button
            className=" absolute right-4 px-2 py-1 bg-black rounded-[4px] text-[white]"
            onClick={() => {
              userVoiceRefetch()
            }}
            type="button"
          >
            불러오기
          </button>
        </>
      )}
    </div>
  )
}
